var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-346 -12)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.004 15.468L5.272 11.736 4 13.008 9.004 18 19.744 7.26 18.472 6z",
      "transform": "translate(346 12)"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }